/* ----------------------------------------------------------------------------
switch between system, light, and dark display modes
---------------------------------------------------------------------------- */
const modes = ['system', 'light', 'dark'];

export default class ThemePicker extends HTMLElement {
	constructor() {
		super();
		this.buttons = [];
		this.handleClick = this.handleClick.bind(this);
		this.currentMode = null;
	}

	getMode() {
		const mode = window.localStorage.getItem('mode');
		return modes.includes(mode) ? mode : 'system';
	}

	saveValue(value) {
		if (!modes.includes(value)) return;

		window.localStorage.setItem('mode', value);
		this.updateButtons(value);
		this.applyValue();
	}

	applyValue() {
		const mode = this.getMode();

		if (this.currentMode && this.currentMode !== 'system') {
			this.target.classList.remove(this.currentMode);
		}

		if (mode !== 'system') {
			this.target.classList.add(mode);
		}

		this.currentMode = mode;
	}

	updateButtons(value) {
		const currentActive = this.querySelector('[aria-current="true"]');
		if (currentActive) {
			currentActive.removeAttribute('aria-current');
		}

		const newActive = this.querySelector(`[data-value="${value}"]`);
		if (newActive) {
			newActive.setAttribute('aria-current', 'true');
		}
	}

	handleClick(e) {
		const button = e.currentTarget;
		const value = button.getAttribute('data-value');
		this.saveValue(value);
	}

	setupControls() {
		this.buttons = Array.from(this.querySelectorAll('[data-value]'));
		for (const element of this.buttons) {
			element.addEventListener('click', this.handleClick);
		}
	}

	connectedCallback() {
		this.target = document.documentElement;
		this.currentMode = this.getMode();
		this.updateButtons(this.currentMode);
		this.applyValue();
		this.setupControls();
	}

	disconnectedCallback() {
		if (this.buttons.length > 0) {
			for (const element of this.buttons) {
				element.removeEventListener('click', this.handleClick);
			}
		}
	}
}

window.customElements.define('theme-picker', ThemePicker);
